export default __webpack_public_path__ + "static/media/misc-books2-1920w.5c9ba19f.png";